module.exports = __webpack_public_path__ + "static/media/2.807b02a8.jpg";